import React, {useEffect, useState} from "react";
import apiClient from "../../../../services/api-client";
import {Skeleton} from "primereact/skeleton";
import {useMountEffect} from "primereact/hooks";
import StorageHelper from "../../../../utils/storage-helper";
import SectionHeader from "../../../../components/ui/SectionHeader";

import EasipolPolicyDisplay from './displays/EasipolPolicyDisplay';
import PendingApplicationPolicyDisplay from './displays/PendingApplicationPolicyDisplay';
import NewApplicationPolicyDisplay from './displays/NewApplicationPolicyDisplay';
import NewLifeApplicationPolicyDisplay from './displays/NewLifeApplicationPolicyDisplay';

const BalanceWidget = () => {
    const [policyDisplay, setpolicyDisplay] = useState(null);
    const [loading, setLoading] = useState(true);
    const [policyValue, setpolicyValue] = useState(null);
    const [policyDisplayKey, setpolicyDisplayKey] = useState(1);

    let userProfile = {};

    function parseTrackApplicationResponse(apiResponse, policyDisplayKey) {
        setLoading(false);
        //console.log(apiResponse);
        if (
            apiResponse &&
            apiResponse.responseBody &&
            !Array.isArray(apiResponse.responseBody) &&
            apiResponse.responseBody.policyApplicationRequestId
        ) {
            //console.log("---- Yes");
            return (
                <>
                    <div className="row dl-equal-row">
                        <div className="col-xxl-4 col-xl-4 col-lg-12 dl-equal-col">
                            {/* <News /> */}
                        </div>
                        <div className="col-xxl-8 col-xl-8 col-lg-12 dl-equal-col">
                            <PendingApplicationPolicyDisplay
                                applicationDetail={apiResponse.responseBody}
                            />
                        </div>
                    </div>
                </>
            );
        } else if (
            apiResponse &&
            apiResponse.responseBody &&
            Array.isArray(apiResponse.responseBody) &&
            apiResponse.responseBody.length > 0
        ) {
            //console.log("---- NO");
            return (
                <EasipolPolicyDisplay key={policyDisplayKey} policyList={apiResponse.responseBody}
                                      policyDisplayKey={policyDisplayKey} apiResponse={apiResponse}
                                      updateSelectedPolicy={updateSelectedPolicy}/>
            );
        } else {
            //console.log("---- MAYbe");

            return (
                <NewLifeApplicationPolicyDisplay
                    applicationDetail={apiResponse.responseBody}
                />
            );
        }
    }

    useEffect(() => {
        // This effect will run whenever selectedPolicyOBJ changes
        //console.log("policyDisplayKey updated:", policyDisplayKey);
    }, [policyDisplayKey]);

    function updateSelectedPolicy(policyValue, policyList, apiResponse) {
        let policyDisplayKey = policyList.findIndex(
            (item) =>
                item.MainMember.Policy_Number === policyValue.MainMember.Policy_Number
        );
        //console.log(policyDisplayKey)
        //console.log(policyList[policyDisplayKey])
        setpolicyDisplayKey(
            policyList.findIndex(
                (item) =>
                    item.MainMember.Policy_Number === policyValue.MainMember.Policy_Number
            )
        );
        setpolicyDisplay(
            parseTrackApplicationResponse(apiResponse, policyDisplayKey)
        );

        setpolicyValue(policyList[policyDisplayKey]);
        // setpolicyDisplay(parseTrackApplicationResponse(response.data))
    }

    const getPolicyDetails = async () => {
        setLoading(true);
        try {
            userProfile = StorageHelper.get("userProfile");

            await apiClient
                .get(
                    "policy/track/" +
                    userProfile.idnumber
                )
                .then((response) => {
                    if (response.data.status === "SUCCESS") {
                        // //console.log(response);

                        if (response.data.responseBody === null) {
                        } else {
                            // setBalanceDetails(response.data.responseBody);
                        }
                    } else {
                        // //console.log(response.data.status)
                    }
                    // //console.log(userProfile.idnumber);
                    // //console.log(response.data);
                    setLoading(false);
                    setpolicyDisplay(parseTrackApplicationResponse(response.data, 0));
                });
        } catch (error) {
            setLoading(false);
            console.error("Error fetching balance details:", error);
        }
    };

    useMountEffect(() => {
        getPolicyDetails();
    }, []);
    return (
        <>
            <div className="w-full">
                {loading ? (
                    <div className="border border-base-300 rounded-xl p-4 bg-base-100">
                        <div className="flex mb-3">
                            <Skeleton shape="circle" size="4rem" className="mr-2"></Skeleton>
                            <div>
                                <Skeleton width="10rem" className="mb-2"></Skeleton>
                                <Skeleton width="5rem" className="mb-2"></Skeleton>
                                <Skeleton height=".5rem"></Skeleton>
                            </div>
                        </div>
                        <Skeleton width="100%" height="150px"></Skeleton>
                        <div className="flex justify-between mt-3">
                            <Skeleton width="4rem" height="2rem"></Skeleton>
                            <Skeleton width="4rem" height="2rem"></Skeleton>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="w-full">
                            <SectionHeader title="Quick Access Options"/>
                            {policyDisplay}
                        </div>
                        <div className="mt-8 w-full">
                            <NewApplicationPolicyDisplay/>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default BalanceWidget;
